import { render, staticRenderFns } from "./manageProjectClass.vue?vue&type=template&id=326a129c"
import script from "./manageProjectClass.vue?vue&type=script&lang=ts"
export * from "./manageProjectClass.vue?vue&type=script&lang=ts"
import style0 from "./manageProjectClass.vue?vue&type=style&index=0&id=326a129c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports